import _toConsumableArray from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import uploadFile from '@/components/upload/uploadFile.vue';
import { uploadFile as uploadApi } from '@/components/upload/upload';
import { upDesignImg, downDesignDraft } from '@/views/salesCardManagement/api';
export default {
  name: 'printingUploadDialog',
  components: {
    uploadFile: uploadFile
  },
  watch: {
    // 监听对话框显示状态变化，确保每次显示时都更新linkUrl配置
    printingUploadDialog: function printingUploadDialog(newVal) {
      if (newVal) {
        console.log('对话框显示，更新linkUrl配置');
        this.linkUrl = {
          config: '/cardmake/image/upload/config',
          extensions: '/cardmake/image/upload/file-allow-extensions'
        };
      }
    }
  },
  data: function data() {
    return {
      printingUploadDialog: false,
      linkUrl: {
        config: '/cardmake/image/upload/config',
        extensions: '/cardmake/image/upload/file-allow-extensions'
      },
      fileName: '',
      ruleForm: {
        file: [],
        id: ''
      },
      imgType: [],
      formType: '',
      uploadKey: 0 // 新增 uploadKey
    };
  },
  methods: {
    // 上传文件
    uploadFile: function uploadFile() {
      this.linkUrl = {
        config: '/cardmake/image/upload/config',
        extensions: '/cardmake/image/upload/file-allow-extensions'
      };
      this.$refs['uploadBanner'].uploadBanner();
    },
    emitUploadFile: function emitUploadFile(url, val, name) {
      // 判断是否为数组，如果不是则转换为数组
      if (!Array.isArray(this.ruleForm.file)) {
        this.ruleForm.file = [];
      }

      // 添加新文件到数组
      var path = "".concat(this.$ossurl).concat(url);
      this.ruleForm.file.push(path);
    },
    // 下载设计稿
    downFile: function downFile() {
      var _this = this;
      var params = {
        id: this.ruleForm.id
      };
      downDesignDraft(params).then(function (res) {
        _this.$message.warning('开始生成文件，请在【下载中心】查看进度并下载文件到本地');
      });
    },
    // 判断是否为图片
    isImage: function isImage(filePath) {
      var imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];
      var fileExtension = filePath.split('.').pop().toLowerCase();
      return imageExtensions.includes(fileExtension);
    },
    // 获取文件名
    getFileName: function getFileName(filePath) {
      return filePath.split('/').pop();
    },
    // 获取原始数组中的索引
    getOriginalIndex: function getOriginalIndex(item) {
      return this.ruleForm.file.findIndex(function (el) {
        return el === item;
      });
    },
    // 删除数组中的文件
    delStyleImage: function delStyleImage(index) {
      this.ruleForm.file.splice(index, 1);
    },
    // 判断是否为PDF
    isPdf: function isPdf(filePath) {
      var fileExtension = filePath.split('.').pop().toLowerCase();
      return fileExtension === 'pdf';
    },
    // 打开文件
    openFile: function openFile(filePath) {
      window.open(filePath);
    },
    // 删除上传文件
    delFile: function delFile() {
      this.ruleForm.file = [];
      this.fileName = '';
    },
    saveFile: function saveFile() {
      var _this2 = this;
      if (this.ruleForm.file.length === 0) {
        this.$message({
          message: '请上传设计稿',
          type: 'warning'
        });
        return;
      }
      // 创建印刷单 - 物料明细：不调用接口，直接把文件数据传回父组件
      if (this.skipApiSubmit) {
        var files = _toConsumableArray(this.ruleForm.file);
        this.handleClose();
        this.$emit('emitGet', files);
        return;
      }
      var params = this.ruleForm;
      upDesignImg(params).then(function () {
        _this2.handleClose();
        _this2.$emit('emitGet');
      });
    },
    // 粘贴截图上传
    handlePaste: function handlePaste(event) {
      var items = (event.clipboardData || window.clipboardData).items;
      var file = null;
      if (!items || items.length === 0) {
        this.$message.error('当前浏览器不支持');
        return;
      }
      // 搜索剪切板items
      for (var i = 0; i < items.length; i++) {
        if (items[i].type.indexOf('image') !== -1) {
          file = items[i].getAsFile();
          break;
        }
      }
      if (!file) {
        this.$message.error('粘贴内容非图片');
        return;
      }
      // 此时file就是我们的剪切板中的图片对象
      var reader = new FileReader();
      reader.onload = function (event) {
        // 可以在这里添加预览逻辑
      };
      reader.readAsDataURL(file);
      this.uploadFilePaste(file);
    },
    // 上传粘贴的图片
    uploadFilePaste: function uploadFilePaste(param) {
      var _this3 = this;
      var file = param;
      var loading = this.$loading({
        lock: true,
        text: '上传中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      uploadApi(file).then(function (response) {
        if (response.status === 200) {
          var url = "".concat(_this3.$ossurl).concat(response.config.key);
          _this3.ruleForm.file.push(url);
        } else {
          var error = new Error('后台错误信息：' + response.msg);
          return Promise.reject(error);
        }
      }).catch(function (error) {
        console.log(error);
        _this3.$message.error('上传失败：' + error.message);
      }).finally(function () {
        loading.close();
      });
    },
    handleClose: function handleClose() {
      this.printingUploadDialog = false;
      this.ruleForm = {
        file: [],
        id: ''
      };
    }
  }
};